module.exports = "<app-widgets-searchbox config=$ctrl.bookSearchConfig placeholder=\"{{ 'Search' | translate }}\" value=$ctrl.book show-clear=true> </app-widgets-searchbox> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/archive/edit/book/partial.html
// module id = 394
// module chunks = 0